import { render, staticRenderFns } from "./BookingStatus.vue?vue&type=template&id=0a150adc&scoped=true"
import script from "./BookingStatus.vue?vue&type=script&lang=ts"
export * from "./BookingStatus.vue?vue&type=script&lang=ts"
import style0 from "./BookingStatus.vue?vue&type=style&index=0&id=0a150adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a150adc",
  null
  
)

export default component.exports